module.exports = __webpack_public_path__ + "img/car_shina2_48.ed3a741a.jpg";